import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom';
import styles from './create-account-style.module.css';
import { getAccountRequestDetails, createNewAccount } from '../firebase/firebase';
import ProfilePicEditor from '../Account/ProfilePicEditor';
import { Timestamp } from 'firebase/firestore';

const WAITING = 0x23;
const passwordEye = '/images/password-eye.png';
const passwordEyeSlash = '/images/password-eye-slash.png';

export default function CreateAccount({setShowNavBar}) {
    useEffect(() => setShowNavBar(false));
    const navigation = useNavigate();
    const params = useParams();

    const [request, setRequest] = useState(WAITING);
    const [birthdate, setBirthdate] = useState('');
    const [passwords, setPasswords] = useState(["", ""]);
    const [profilePic, updateProfilePic] = useState('#5C6C41');
    const [mouseCords, setMouseCords] = useState({x: 0, y: 0});
    const [mouseDown, setMouseDown] = useState(false);

    const [icon, setIcon] = useState(passwordEye);
    const [type, setType] = useState('password');

    useEffect(() => { getAccountRequestDetails(params.id).then((doc) => {
        let data = doc.data();

        if(data != null) data.id = doc.id;
        
        setRequest(data);
    })}, [params.id, setRequest]);

    const handleSubmit = (e) => {
        e.preventDefault();

        let elementID = null;

        if (birthdate === '') {
            elementID = 'birthdate';
        } else if (passwords[0] === '') {
            elementID = 'password';
        } else if (passwords[1] === '') {
            elementID = 'password-again';
        } else if (passwords[0] !== passwords[1]) {
            elementID = 'password';
        }

        if(elementID != null) {
            const element = document.getElementById(elementID);
            element.focus();
            element.classList.add(styles.empty_field);        
        } else {
            let timestampBirthdate = new Timestamp(new Date(birthdate).getTime() / 1000 + 8*60*60, 0);
            createNewAccount(request, passwords[0], timestampBirthdate, profilePic);
            navigation('/home');
        }      
    }
    const handleToggle = () => {
        if (type==='password'){
           setIcon(passwordEyeSlash);
           setType('text')
        } else {
           setIcon(passwordEye)
           setType('password')
        }
     }

    if(request === WAITING) {
        return (
            <div className={styles.container}>
                <div className={styles.signup_container} style={{opacity: 0}}></div>
            </div>        
        )
    } else if (request == null || request.pending !== "Email Sent") {
        const emailLink = `mailto:whitaker@thecampbytheriver.com`;
        return (
            <div className={styles.container}>
                <div className={styles.signup_container} style={{opacity: 1}}>
                    <div className={styles.details}>
                        <img className={styles.icon} src="/images/logo/chautauqua-interconnect-icon.svg" alt="The Chautauqua Interconect Logo"/>
                        <h1>Chautauqua Interconnect</h1>
                    </div> 
                    <h1>Invalid Link</h1>
                    <p>Please verify the link is correct and you have not already created an account (try <Link to='/signin'>signing in</Link>.).If you are still experencing issues, please email <Link to={emailLink}>whitaker@thecampbytheriver.com</Link></p>
                </div>
            </div>        
        )
    }
    return (
        <div className={styles.container} id='main-container' 
                    onMouseMove={(e) => {setMouseCords({x: e.pageX, y: e.pageY})}}
                    onMouseDown={() => {setMouseDown(true)}}
                    onMouseUp={() => {setMouseDown(false)}}>
            <div className={styles.signup_container} style={{opacity: 1}}>
                <div className={styles.details}>
                    <img className={styles.icon} src="/images/logo/chautauqua-interconnect-icon.svg" alt="The Chautauqua Interconect Logo"/>
                    <h1>Chautauqua Interconnect</h1>
                </div> 
                <form className={styles.form}>
                    <h3>Welcome, {request.first_name}!</h3>
                    <p>Please fill in the below information to create your account.</p>
                    <label htmlFor='birthdate'>Birthdate<span style={{color: 'red'}}>*</span></label>
                    <input type="date" id='birthdate' className={styles.input} onChange={(e) => {setBirthdate(e.target.value); e.target.classList.remove(styles.empty_field)}} autoComplete='bday'/>

                    <label>Profile Picture</label>
                    <ProfilePicEditor profilePic={profilePic} updateProfilePic={updateProfilePic} mouseCords={mouseCords} mouseDown={mouseDown} firstInitial={request?.first_name?.[0]}/>

                    <label htmlFor='password'>Password<span style={{color: 'red'}}>*</span></label>
                    <input type={type} id='password' className={styles.input} onChange={(e) => {setPasswords([e.target.value, passwords[1]]); e.target.classList.remove(styles.empty_field);}} autoComplete='new-password'/>
                    <span><img className={styles.eye} alt="View Password Eye" src={icon} onClick={handleToggle}/></span>

                    <label htmlFor='password-again'>Retype Password<span style={{color: 'red'}}>*</span></label>
                    <input type={type} id='password-again' className={styles.input} onChange={(e) => {setPasswords([passwords[0], e.target.value]); e.target.classList.remove(styles.empty_field)}}  autoComplete='new-password'/>
                    <span><img className={styles.eye} alt="View Password Eye" src={icon} onClick={handleToggle}/></span>
                    <p style={{color: 'red', margin: '-16px 0 16px 0', textAlign: 'center', visibility: (passwords[0] === passwords[1]) ? 'hidden' : 'visible'}}>Passwords do not match.</p>
                    <p style={{color: 'red', margin: '0 0 0 0', textAlign: 'center', visibility: (passwords[0].length > 6 || passwords[0].length <  1) ? 'hidden' : 'visible'}}>Password must be more than 6 characters.</p>
                    <p style={{color: 'red', margin: '16px 0 0 0', textAlign: 'center'}}>* Indicates required field</p>
                    <div>
                        <button className={styles.create_btn} onClick={(e) => handleSubmit(e)}>Create Account</button>
                    </div>                    
                </form>
            </div>
        </div>        
    )
}
